// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"731613be","890":"40c4c87d"}[chunkId] + ".chunk.js";
};